// extracted by mini-css-extract-plugin
export default {"keyword-match-quotas":"keyword-match-quotas","keywordMatchQuotas":"keyword-match-quotas","low":"low","medium":"medium","high":"high"};